// apps/app/src/state/notifications/resources.ts
import { api } from '@api'

// Get paginated notifications
export const handleGetNotifications = async (userId: string, pageParam = 0) => {
  const PAGE_SIZE = 5
  const from = pageParam * PAGE_SIZE
  const to = from + PAGE_SIZE - 1

  const { data, error } = await api()
    .from('notification')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false }) // Make sure newest are first
    .range(from, to)

  if (error) {
    console.error('Error fetching notifications:', error)
    return { data: [], nextCursor: undefined }
  }

  // If we got a full page, there might be more. Otherwise, we're at the end.
  const nextCursor = data?.length === PAGE_SIZE ? pageParam + 1 : undefined

  return { data: data || [], nextCursor }
}

export const handleMarkNotificationRead = async (notificationId: string | null) => {
  if (!notificationId) return

  const { error } = await api()
    .from('notification')
    .update({
      read_at: new Date().toISOString(),
    })
    .eq('id', notificationId)

  if (error) {
    console.error('Error updating notification:', error)
    return { success: false }
  }

  return { success: true }
}

export const handleClearAllNotifications = async (userId: string | null) => {
  if (!userId) return

  const { error } = await api()
    .from('notification')
    .update({
      read_at: new Date().toISOString(),
    })
    .eq('user_id', userId)
    .is('read_at', null)

  if (error) {
    console.error('Error clearing all notifications:', error)
    return { success: false }
  }

  return { success: true }
}

export const handleGetUnreadNotifications = async (userId: string) => {
  const { data, error } = await api()
    .from('notification')
    .select('*')
    .eq('user_id', userId)
    .is('read_at', null)
    .order('created_at', { ascending: false })
    .limit(10) // Only grab the latest 10 for the popover

  if (error) {
    console.error('Error fetching unread notifications:', error)
    return []
  }

  return data || []
}
